import { createContext } from 'react';
import { ViewModel } from '@steelbuy/ts-shared';

import { EntityDataProviderValue, defaultEntityDataValue } from './EntityDataProviderValue';

export const createEntityDataContext = <Model extends ViewModel>(): React.Context<EntityDataProviderValue<Model>> =>
    createContext<EntityDataProviderValue<Model>>(defaultEntityDataValue);
